import AuditService from "../../services/auditConfigService";
import * as types from "./types";
import { initialState } from "./initialState";
import { errorMessage } from "../../constants/responseMessages";

const service = new AuditService();

// export const mockAuditTrailFiltersData = {
//   event_names: [
//     { value: "Parameter Updated", label: "Parameter Updated" },
//     { value: "Unit Operation Updated", label: "Unit Operation Updated" },
//   ],
//   updated_by: [
//     { value: "Emma L.", label: "Emma L." },
//     { value: "David K.", label: "David K." },
//   ],
//   status: [
//     { value: "Approved", label: "Approved" },
//     { value: "Rejected", label: "Rejected" },
//     { value: "Draft", label: "Draft" },
//   ],
// };

// export const versions = [
//   {
//     version_id: "v7",
//     version_label: "v7",
//     status: "Approved",
//     updated_on: "20 Jul 2026, 11:30 AM",
//     updated_by: "John Doe",
//     updated_ref: "AUD-10541",
//     changed_fields_summary: "Target Value, Unit, Mandatory",
//     changes: [
//       { field: "Target Value", previous_value: "25", new_value: "30" },
//       { field: "Unit", previous_value: "°F", new_value: "°C" },
//       { field: "Mandatory", previous_value: "No", new_value: "Yes" },
//     ],
//   },
//   {
//     version_id: "v6",
//     version_label: "v6",
//     status: "Approved",
//     updated_on: "17 Jul 2026, 04:22 PM",
//     updated_by: "Admin User",
//     updated_ref: "AUD-10488",
//     changed_fields_summary: "Status",
//     changes: [
//       {
//         field: "Status",
//         previous_value: "Draft",
//         new_value: "Approved",
//       },
//     ],
//   },
//   {
//     version_id: "v5",
//     version_label: "v5",
//     status: "Updated",
//     updated_on: "17 Jul 2026, 02:08 PM",
//     updated_by: "Priya Shah",
//     updated_ref: "AUD-10460",
//     changed_fields_summary: "Formula, Status",
//     changes: [
//       {
//         field: "Formula",
//         previous_value: "T(°C) = (T(°F) - 32) / 1.8",
//         new_value: "T(°C) = (T(°F) - 32) × 5/9",
//       },
//       {
//         field: "Status",
//         previous_value: "Rejected",
//         new_value: "Draft",
//       },
//     ],
//   },
//   {
//     version_id: "v4",
//     version_label: "v4",
//     status: "Updated",
//     updated_on: "10 Jul 2026, 10:15 AM",
//     updated_by: "John Doe",
//     updated_ref: "AUD-10391",
//     changed_fields_summary: "Target Value",
//     changes: [{ field: "Target Value", previous_value: "22", new_value: "25" }],
//   },
//   {
//     version_id: "v3",
//     version_label: "v3",
//     status: "Updated",
//     updated_on: "6 Jul 2026, 03:40 PM",
//     updated_by: "Priya Shah",
//     updated_ref: "AUD-10312",
//     changed_fields_summary: "Parameter Name",
//     changes: [
//       {
//         field: "Parameter Name",
//         previous_value: "Temp Sensor Reading",
//         new_value: "Temperature",
//       },
//     ],
//   },
// ];

export const getAuditList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_AUDIT,
      payload: { ...initialState, loading: true },
    });
    service
      .getAuditList(data)
      .then((res) => {
        dispatch({
          type: types.GET_AUDIT,
          payload: { data: res.data.data, loading: false, status: 200 },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_AUDIT,
          payload: {
            ...initialState,
            message: error.message || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const getConfigAuditTrailList = (data) => {
  return (dispatch, getState) => {
    // const prevState = getState().auditConfig.configAuditTrailList;

    dispatch({
      type: types.GET_CONFIG_AUDIT_TRAIL,
      payload: {
        message: null,
        next: false,
        apiError: false,
        apiSuccess: false,
        data: [],
        loading: true,
      },
    });

    service
      .getConfigAuditTrailList(data)
      .then((res) => {
        dispatch({
          type: types.GET_CONFIG_AUDIT_TRAIL,
          payload: {
            data: res.data.data,
            loading: false,
            next: false,
            apiError: false,
            apiSuccess: true,
            message: null,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_CONFIG_AUDIT_TRAIL,
          payload: {
            data: [],
            loading: false,
            next: false,
            apiError: true,
            apiSuccess: false,
            message: errorMessage(error),
          },
        });
      });
  };
};

export const getConfigurationFiltersList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_CONFIG_AUDIT_TRAIL_FILTERS,
      payload: { ...initialState, loading: true },
    });
    service
      .getConfigurationFiltersList(data)
      .then((res) => {
        dispatch({
          type: types.GET_CONFIG_AUDIT_TRAIL_FILTERS,
          payload: { data: res.data.data, loading: false, status: 200 },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_CONFIG_AUDIT_TRAIL_FILTERS,
          payload: {
            ...initialState,
            message: error.message || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        // dispatch({
        //   type: types.GET_CONFIG_AUDIT_TRAIL_FILTERS,
        //   payload: {
        //     ...mockAuditTrailFiltersData,
        //     // loading: false,
        //     // status: 200,
        //   },
        // });
      });
  };
};

export const clearConfigAuditTrailList = () => {
  return (dispatch) => {
    dispatch({
      type: types.GET_CONFIG_AUDIT_TRAIL,
      payload: { ...initialState },
    });
  };
};

export const clearConfigurationVersions = () => {
  return (dispatch) => {
    dispatch({
      type: types.GET_CONFIG_VERSIONS,
      payload: { ...initialState },
    });
  };
};

export const getConfigurationVersions = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_CONFIG_VERSIONS,
      payload: {
        // ...initialState,
        loading: true,
        message: null,
        next: false,
        apiError: false,
        apiSuccess: false,
        data: [],
      },
    });
    service
      .getConfigurationVersions(data)
      .then((res) => {
        dispatch({
          type: types.GET_CONFIG_VERSIONS,
          payload: {
            data: res.data.data,
            loading: false,
            next: false,
            apiError: false,
            apiSuccess: true,
            message: null,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_CONFIG_VERSIONS,
          payload: {
            data: [],
            loading: false,
            status: error.response?.status || 500,
            next: false,
            apiError: true,
            apiSuccess: false,
            message: errorMessage(error),
          },
        });
        // dispatch({
        //   type: types.GET_CONFIG_VERSIONS,
        //   payload: versions,
        // });
      });
  };
};

export const exportConfigAuditTrailList = (data) => {
  return () => {
    return service.exportConfigAuditTrailList(data);
  };
};

export const getConfigAuditTrailExportStatus = (taskId) => {
  return () => {
    return service.getConfigAuditTrailExportStatus(taskId);
  };
};
